import axios from 'axios';

const state= {
    EquipmentStructure:{
        items:[],
        total:0
    },
    EquipmentStructureLoadings:{
        list:true
    }
};

const getters = {
    EquipmentStructure : (state) => state.EquipmentStructure,
    EquipmentStructureLoadings : (state) => state.EquipmentStructureLoadings,
};

const actions = {
    async getItems({commit}, params){
        let page = params.page || 1;
        let limit = params.limit || 25;
        let filter = params.filter;
        return new Promise (( resolve, reject ) => {
            commit( 'setEquipmentStructureLoadings', {key:"list",val:true});
            global.axios.get(`api/equipment/structure`, {params:{
                    page:page,
                    limit:limit,
                    filter:filter,
                    contract_id : filter.contract_id
                }})
                .then(response => {
                    commit( 'setEquipmentStructureLoadings', {key:"list",val:false});
                    commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async uploadFileImport({commit}, params){
        return new Promise (( resolve, reject ) => {
          let formData = new FormData();
          formData.append('file_import', params.file);
          formData.append('contract_id', params.contract_id);
          formData.append('is_master', params.is_master);
          global.axios.post(`api/equipment/structure/import`,formData,
          {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
          })
          .then(response => {
    
            resolve( response );
          })
          .catch(error => reject( error ));
        })
      },
    async importCustomFields({commit}, params){
        return new Promise (( resolve, reject ) => {
          let formData = new FormData();
          formData.append('file_import', params.file);
          formData.append('contract_id', params.contract_id);
          global.axios.post(`api/equipment/structure/import/custom-field`,formData,
          {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
          })
          .then(response => {

            resolve( response );
          })
          .catch(error => reject( error ));
        })
      }
};

const mutations = {
    setItems (state,data) {
        state.EquipmentStructure.items = data.items;
        state.EquipmentStructure.total = data.total;
    },
    setEquipmentStructureLoadings (state,data) {
        if(data.key === "list"){
            state.EquipmentStructureLoadings.list = data.val;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}